import { Injectable } from '@angular/core';
import { SearchAccountsSimpleResponseItem } from '../../core/openapi/bff-user-portal';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class ObservableAccountService {
  private readonly selectedAccount$ = new BehaviorSubject<SearchAccountsSimpleResponseItem | null>(null);

  public getCurrentAccount$(): Observable<SearchAccountsSimpleResponseItem | null> {
    return this.selectedAccount$.asObservable();
  }

  public setCurrentAccount(account: SearchAccountsSimpleResponseItem | null): void {
    this.selectedAccount$.next(account);
  }
}
